export const isCSSVariable = (value: string): boolean => {
    const cssVarRegex = /^var\(--[a-zA-Z0-9_-]+\)$/
    return cssVarRegex.test(value)
}
